export default __webpack_public_path__ + "static/media/Robert.211f6be5.png";